import { render, staticRenderFns } from "./CardCustomizationSection.vue?vue&type=template&id=c683e12c"
import script from "./CardCustomizationSection.vue?vue&type=script&lang=ts"
export * from "./CardCustomizationSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports